module.exports = __webpack_public_path__ + "static/img/new_seven.5f6546b3.jpg";